<template>
    <Page withNavbar>
        <Header/>
        <main>
            <!-- Info -->
            <BriefInfo
                :title="title || config.BRIEF_TITLE"
                :description="description || config.BRIEF_DESCRIPTION"
                :picture="picture || config.BRIEF_REWARD_IMAGE || config.BRIEF_REWARD_IMAGE_MOBILE"
                :pictureAdditional="pictureAdditional"
                :pictureCover="pictureCover"
            >
                <Button :color="config.COLOR_PRIMARY" :disabled="disabled" @click="onCTA">
                    {{ config.BRIEF_RULES_CTA }}
                </Button>
            </BriefInfo>
            <!-- Steps -->
            <BriefSteps
                :steps="steps || briefSteps"
                :video="config.BRIEF_VIDEO_URL"
                :pdf="pdf || config.BRIEF_PDF_URL"
            />
            <!-- Break -->
            <BriefBreak :picture="config.BRIEF_BREAK_IMAGE || config.BRIEF_BREAK_IMAGE_MOBILE"/>
            <!-- Rules -->
            <BriefRules :rules="briefRules">
                <Button :color="config.COLOR_PRIMARY" :disabled="disabled" @click="onCTA">
                    {{ config.BRIEF_RULES_CTA }}
                </Button>
            </BriefRules>
        </main>
        <!-- Modals -->
        <transition name="fade">
            <keep-alive>
                <ModalInformation
                    v-if="askInformation"
                    @close="onInformationClose"
                    @done="onInformationDone"
                />
            </keep-alive>
        </transition>
        <!-- Child routes -->
        <transition name="fade">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </transition>
    </Page>
</template>
<script>
import { SolutionConsumer, ProjectConsumer } from '../../mixins';
import {
    Page,
    Header,
    BriefInfo,
    BriefSteps,
    BriefBreak,
    BriefRules,
    ModalInformation,
} from '../../components/desktop';
import { buildSmartUploaderUrl } from '../../utils';

export default {
    name: 'BriefWithModal',
    components: {
        Page, Header, BriefInfo, BriefSteps, BriefBreak, BriefRules, ModalInformation,
    },
    mixins: [SolutionConsumer, ProjectConsumer],
    props: {
        next: {
            type: String,
            default: 'deposit.contract',
        },
        title: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        picture: {
            type: String,
            default: null,
        },
        pictureAdditional: {
            type: String,
            default: null,
        },
        steps: {
            type: Array,
            default: null,
        },
        pdf: {
            type: String,
            default: null,
        },
        product: {
            type: Object,
            default: null,
        },
        captureFrontUrl: {
            type: String,
            default: null,
        },
        pictureCover: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether to disable the CTA button
         */
        disabled: {
            type: [Boolean, String],
            default: false,
        },
        canUpload: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            askInformation: false,
            smartUploader: this.$store.state.solution.smartUploader,
        };
    },
    computed: {
        smartUploaderUrl () {
            return buildSmartUploaderUrl({
                smartUploaderConfig: this.smartUploader ? this.smartUploader.config : null,
                captureFrontUrl: this.captureFrontUrl,
                ...(this.product ? { product: this.product } : {}),
                ...(this.product ? { order: this.product.order } : {}),
            });
        },
    },
    methods: {
        onCTA () {
            if (this.smartUploader && this.canUpload) {
                window.open(this.smartUploaderUrl, '_blank');
            } else if (this.showUploadInformation && this.shouldAskInformation) {
                this.askInformation = true;
            } else {
                this.$router.push({ name: this.next });
            }
        },
        onInformationClose () {
            this.askInformation = false;
        },
        onInformationDone () {
            this.askInformation = false;
            this.$router.push({ name: this.next });
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

main {
    background-color: $white-dark;
}
</style>
